module.exports = __webpack_public_path__ + "img/logo-inverse.1faa3162.png";